import PropTypes from 'prop-types';
import React from 'react';

import { ConfigsService, LocaleService, WindowProxy } from '@sm360/widget-commons-core-services';
import { AccountService, ModalService, REDIRECTIONS } from '@sm360/widget-commons-general';

import QuoteModel from 'commons-vehicle/Quote/models/QuoteModel.js';
import QuoteService from 'commons-vehicle/Quote/services/QuoteService/QuoteService.js';
import ShowroomService from 'commons-vehicle/services/ShowroomService/ShowroomService.js';

import 'commons-vehicle/Vehicle/components/CallToAction/VehicleCtaBar/VehicleCtaBar.scss';

class TradeInCTA extends React.Component {
    constructor(props) {
        super(props);

        this.onTradeInClick = this.onTradeInClick.bind(this);
        this.redirectToTradeIn = this.redirectToTradeIn.bind(this);
        this.saveQuoteAndRedirect = this.saveQuoteAndRedirect.bind(this);
    }

    componentDidMount() {
        const locale = LocaleService.getSimpleLocale();
        this.redirect = REDIRECTIONS[locale].tradeIn;
    }

    onTradeInClick() {
        if (!AccountService.isAuthenticated()) {
            const LoginModal = ModalService.get('login/SignUpModal');
            LoginModal.addCallbacks({
                onClose: () => {
                    if (AccountService.isAuthenticated()) {
                        return this.saveQuoteAndRedirect();
                    }
                    return true;
                },
            });
            LoginModal.open();
        } else {
            this.saveQuoteAndRedirect();
        }
    }

    redirectToTradeIn(showroomQuote) {
        const locale = LocaleService.getSimpleLocale();
        const url = REDIRECTIONS[locale].tradeIn;
        const windowProxy = WindowProxy.get();

        let fullUrl = url;
        if (windowProxy && showroomQuote) {
            const newQuote = QuoteService.resetQuoteFromShowroomSave(this.props.quote, showroomQuote);
            const historyUrl = newQuote.buildUrl(windowProxy.location.href);

            windowProxy.history.replaceState(
                {
                    quote: this.props.quote.getShowroomQuote(),
                },
                'tradeIn',
                historyUrl
            );

            fullUrl = newQuote.buildUrl(url);
        }

        if (ConfigsService.isInMobileApp() && !AccountService.isAuthenticated()) {
            windowProxy.location.href =
                `ca.solutionsmedias360.showroom-${ConfigsService.getWebsiteId()}://` +
                `?action=login&redirectUrl=${encodeURIComponent(fullUrl)}`;
        } else {
            windowProxy.location.href = fullUrl;
        }
    }

    saveQuoteAndRedirect() {
        if (this.props.quote) {
            ShowroomService.saveQuote(this.props.quote.getShowroomQuote()).then(this.redirectToTradeIn);
        } else {
            this.redirectToTradeIn();
        }
    }

    render() {
        const currentClass = [this.props.buttonClass, 'vehicle-cta-btn'];
        return (
            <button className={currentClass.join(' ')} onClick={this.onTradeInClick}>
                <span>{LocaleService.t('CALL_TO_ACTION.BTN_EXCHANGE_TITLE')}</span>
            </button>
        );
    }
}

TradeInCTA.defaultProps = {
    buttonClass: 'sr-button-2',
};

TradeInCTA.propTypes = {
    buttonClass: PropTypes.string,
    quote: PropTypes.instanceOf(QuoteModel).isRequired,
};

TradeInCTA.displayName = 'TradeInCTA';

export default TradeInCTA;



// WEBPACK FOOTER //
// ./src/Vehicle/components/CallToAction/TradeIn/TradeInCTA.jsx